import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { passwordResetByUsername } from "../../api/requests";

function Login() {
    const navigate = useNavigate();
    const [identifier, setIdentifier] = useState(""); // Username oder Email
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    // Passwort-Reset (Modal)
    const [showResetModal, setShowResetModal] = useState(false);
    const [resetUsername, setResetUsername] = useState("");
    const [resetError, setResetError] = useState("");
    const [resetSuccess, setResetSuccess] = useState("");
    const [resetSubmitting, setResetSubmitting] = useState(false);

    // User-Login-Handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login/`, {
                username: identifier, // Email
                password,
            });
            const accessToken = response.data.access;
            if (accessToken) {
                localStorage.setItem("token", accessToken);
                const decoded = jwtDecode(accessToken);
                // Optional: User-Infos speichern
                localStorage.setItem("user_role", decoded.is_admin ? "admin" : "user");
                setError("");
                navigate("/", { replace: true });
            } else {
                setError("Login fehlgeschlagen.");
            }
        } catch (err) {
            setError("Login fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.");
        }
    };

    const openResetModal = () => {
        setResetUsername(identifier || "");
        setResetError("");
        setResetSuccess("");
        setShowResetModal(true);
    };

    const closeResetModal = () => {
        setShowResetModal(false);
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setResetSubmitting(true);
        setResetError("");
        setResetSuccess("");
        try {
            await passwordResetByUsername(resetUsername);
            // Generische Erfolgsmeldung (kein User-Enumeration)
            setResetSuccess(
                "Wenn ein Konto existiert, wurde eine E-Mail zum Zurücksetzen des Passworts versendet."
            );
        } catch (err) {
            setResetError(
                "Passwort-Reset fehlgeschlagen. Bitte versuchen Sie es später erneut."
            );
        } finally {
            setResetSubmitting(false);
        }
    };

    return (
        <>
            {/* Benutzer-Login */}
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicIdentifier">
                    <Form.Label>E-Mail</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="E-Mail"
                        value={identifier}
                        onChange={e => setIdentifier(e.target.value)}
                    />
                    <Form.Text className="text-muted">
                        Anmeldung mit E-Mail.
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                </Form.Group>

                <div className="d-flex justify-content-end">
                    <Button variant="link" type="button" onClick={openResetModal}>
                        Passwort vergessen?
                    </Button>
                </div>

                {error && <p style={{ color: "red" }}>{error}</p>}
                <Button variant="primary" type="submit" className="m-5" size="lg">
                    Submit
                </Button>
            </Form>

            {/* Passwort-Reset Modal */}
            <Modal show={showResetModal} onHide={closeResetModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Passwort zurücksetzen</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handlePasswordReset}>
                        <Form.Group className="mb-3" controlId="passwordResetUsername">
                            <Form.Label>E-Mail</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="E-Mail"
                                value={resetUsername}
                                onChange={(e) => setResetUsername(e.target.value)}
                                autoFocus
                            />
                            <Form.Text className="text-muted">
                                Gib die E-Mail ein, mit der du dich anmeldest.
                            </Form.Text>
                        </Form.Group>

                        {resetError && <p style={{ color: "red" }}>{resetError}</p>}
                        {resetSuccess && <p style={{ color: "green" }}>{resetSuccess}</p>}

                        <div className="d-flex justify-content-end gap-2">
                            <Button variant="secondary" type="button" onClick={closeResetModal} disabled={resetSubmitting}>
                                Schließen
                            </Button>
                            <Button variant="primary" type="submit" disabled={resetSubmitting || !resetUsername.trim()}>
                                {resetSubmitting ? "Senden..." : "Reset-Link senden"}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Login;